import i18n from '../../VueI18n'

export const variaveisBiometricas = [
	{ key: 'volumeTotalComCasca', label: i18n.t('volumeTotalComCasca') },
	{ key: 'volumeTotalSemCasca', label: i18n.t('volumeTotalSemCasca') },
	{ key: 'arvoresMedVolumeTotalComCasca', label: i18n.t('arvoresMedVolumeTotalComCasca') },
	{ key: 'arvoresMedVolumeTotalSemCasca', label: i18n.t('arvoresMedVolumeTotalSemCasca') },
	{ key: 'imaComCasca', label: i18n.t('imaComCasca') },
	{ key: 'imaSemCasca', label: i18n.t('imaSemCasca') },
	{ key: 'areaBasal', label: i18n.t('areaBasal') },
	{ key: 'dg', label: i18n.t('dg') },
	{ key: 'dapMaximo', label: i18n.t('dapMaximo') },
	{ key: 'dapMedio', label: i18n.t('dapMedio') },
	{ key: 'dapMinimo', label: i18n.t('dapMinimo') },
	{ key: 'diametroMaximo', label: i18n.t('diametroMaximo') },
	{ key: 'alturaMaxima', label: i18n.t('alturaMaxima') },
	{ key: 'alturaMedia', label: i18n.t('alturaMedia') },
	{ key: 'alturaMinima', label: i18n.t('alturaMinima') },
	{ key: 'alturaDominante', label: i18n.t('alturaDominante') },
	{ key: 'numeroDeFustes', label: i18n.t('numeroDeFustes') },
	{ key: 'arvoresUteis', label: i18n.t('arvoresUteis') },
	{ key: 'numeroDePerdas', label: i18n.t('numeroDePerdas') },
	{ key: 'numeroDeCovas', label: i18n.t('numeroCovas') },
	{ key: 'proporcaoArvoresUteis', label: i18n.t('proporcaoArvoresUteis') },
	{ key: 'proporcaoDePerdas', label: i18n.t('proporcaoDePerdas') },
	{ key: 'volumeTotalDeMortasComCasca', label: i18n.t('volumeTotalDeMortasComCasca') },
	{ key: 'volumeTotalDeMortasSemCasca', label: i18n.t('volumeTotalDeMortasSemCasca') },
]
